'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.connectWithStore = connectWithStore;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = require('redux-logger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Store = function () {
    function Store(name, reducer) {
        var _this = this;

        _classCallCheck(this, Store);

        this.name = name;

        var loggerMiddleware = (0, _reduxLogger.createLogger)();
        var enhancer = (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default, loggerMiddleware));
        var persistedState = localStorage.getItem(this.name) ? JSON.parse(localStorage.getItem(this.name)) : {};
        var rootReducer = (0, _redux.combineReducers)(reducer);

        this.store = (0, _redux.createStore)(rootReducer, persistedState, enhancer);
        this.store.subscribe(function () {
            var state = _this.store.getState();
            // state = [...state]
            var stateStr = JSON.stringify(state);
            // console.log(`store size (before compact): ${stateStr.length / 1000}KB`)

            // // TODO: iterate entire state prop to detemine of type array and do compact 
            // let chats = state.chatState.chats
            // state.chatState.chats = chats.filter(n => n)
            // stateStr = JSON.stringify(state)
            // console.log(`store size: ${stateStr.length / 1000}KB`)
            localStorage.setItem(_this.name, stateStr);
        });
    }

    _createClass(Store, [{
        key: 'getStore',
        value: function getStore() {
            return this.store;
        }
    }]);

    return Store;
}();

// HOC


exports.default = Store;
function connectWithStore(store, WrappedComponent) {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
    }

    var ConnectedWrappedComponent = _reactRedux.connect.apply(undefined, args)(WrappedComponent);
    return function (props) {
        return _react2.default.createElement(ConnectedWrappedComponent, _extends({}, props, { store: store }));
    };
}


// WEBPACK FOOTER //
// ../chat/lib/common/store.js